import { IFutureRoad as IFutureRoadEntity } from 'shared/common/repositories/infrastructure-caching/entities/newbuilding_infrastructure/FutureRoad';
import { IFutureRoadSchema } from 'shared/common/repositories/infrastructure-caching/entities/newbuilding_infrastructure/FutureRoadSchema';
import { IFutureRoad } from 'shared/mf-infrastructure/types/futureInfrastructure';

export const transformFutureRoads = (
  futureRoads?: Array<IFutureRoadSchema | IFutureRoadEntity> | null,
): IFutureRoad[] => {
  if (!futureRoads) {
    return [];
  }

  return futureRoads.map(road => ({
    ...road,
    type: 'futureRoad',
    constructionYearTo: road.constructionYearTo || undefined,
  }));
};
